<template>
  <div id="app">
    <template v-if="$route.name !== 'splash'">
      <Navbar />
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
      <AppFooter />
    </template>
    <template v-else>
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </template>
  </div>
</template>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>

<script>
import Navbar from '@/components/Navbar'
import AppFooter from '@/components/AppFooter'

export default {
  name: 'App',
  components: {
    Navbar,
    AppFooter
  }
}
</script>
